import { Color } from "@skillscratch/shared-constants";
import type { CSSProperties, ReactNode } from "react";

export interface BoxProps {
  style?: CSSProperties;
  className?: string;
  children: ReactNode;
}

export function Box({ style, className = "", children }: BoxProps) {
  return (
    <div
      className={className}
      style={{
        background: className ? undefined : "#fff",
        color: Color.darkBlue,
        ...style,
      }}
    >
      {children}
    </div>
  );
}